import { Activity, MessageSquare, ThumbsUp, Users, Calendar, Star } from "lucide-react"
import CommunityBanner from "./CommunityBanner"
import { useCommunity } from "../../context/CommunityContext"

export function CommunityDashboardPage() {
  const communityCtx = useCommunity();

  console.log(communityCtx);

  return (
    <div className="space-y-8 max-w-[2000px] mx-auto">
      <CommunityBanner
        title={communityCtx.community.community.name}
        description={communityCtx.community.community.description}
        logoImage={communityCtx.community.community.profilePicture}
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="glass-card rounded-xl p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-gradient-1">
              <Users className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Total Members</p>
              <p className="text-2xl font-bold">{communityCtx.community.community.memberCount}</p>
            </div>
          </div>
        </div>

        <div className="glass-card rounded-xl p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-gradient-2">
              <MessageSquare className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Active Discussions</p>
              <p className="text-2xl font-bold">482</p>
            </div>
          </div>
        </div>

        <div className="glass-card rounded-xl p-6">
          <div className="flex items-start gap-4">
            <div className="p-3 rounded-xl bg-gradient-1">
              <Activity className="w-6 h-6 text-white" />
            </div>
            <div>
              <p className="text-sm text-gray-500">Engagement Rate</p>
              <p className="text-2xl font-bold">64%</p>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">

      </div>
    </div>
  );
}
